import { Pet } from './pet';
import { Person } from './person';

/**
 * Classe que representa o Tutor do animal
 * @extends Person
 */
export class Guardian extends Person {
    /** Animais, <Array:Firebase> */
    pets: Array<Pet>;

    /**
     * Instanciar um novo Tutor
     * @param init - JSON que represente parcialmente as propriedades da classe
     */
    public constructor(init?: Partial<Guardian>) {
        super(init);
        Object.assign(this, init);
    }

    /**
     *
     */
    toFirebase(): object {
        return {
            name: this.name,
            document: this.document,
            birthday: this.birthday || null,
            phone: this.phone,
            user: this.user ? this.user.toFirebase() : null,
            address: this.address ? this.address.toFirebase() : null,
        };
    }
}
